import React, { useEffect, useState } from "react";
import * as d3 from "d3";
import { getAcademicYear } from "../../Shared/Utility";
const colorsForBars = [
  "#336699",
  "#E8AB59",
  "#D8DDE0",
  "#D1DB82",
  "#E2D4CB",
  "#D6EDF6",
  "#A6C3C1",
  "#D2AA87",
  "#B9e8f1",
  "#274b63",
  "#46d39a",
  "#64b5f6",
  "#BFE8FF",
  "#0075A4",
  "#FFB996",
  "#7BD3EA",
  "#B0A695",
  "#8EACCD",
  "#D7F1D3",
  "#D8E7F7",
  "#F6CBCB",
  "#F3D2F1"
];
const AreaGraphND1 = (props ) => {
  var data = props.data;
var Arealegends = props.Arealegends;
  // Set up dimensions and margins
  var divWidth =
    document.getElementById("stacked-area-graph-container")?.clientWidth || 30;
  const margin = { top: 20, right: 20, bottom: 50, left: 60 };
  var width = divWidth - margin.left - margin.right;
  const height = 200 - margin.top - margin.bottom;

  const [refresh, setrefresh] = useState(false);
  useEffect(() => {
    divWidth =
      document.getElementById("stacked-area-graph-container")?.clientWidth ||
      30;

    width = divWidth - 15 - margin.left - margin.right || 0;

    setrefresh(!refresh);
  }, [width]);

  useEffect(() => {
    // Sample data with years and multiple values

    // Create SVG container for the main graph
    const svg = d3
      .select("#stacked-area-graph-container")
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    // Create SVG container for the legend
    // const legendSvg = d3
    //   .select("#stacked-area-legend-container")
    //   .append("svg")
    //   .attr("width", 60)
    //   .attr("height", 17);

    // Define scales
    // const xScale = d3
    // .scaleTime()
    //.domain(d3.extent(data, (d) => new Date(d.year, 0, 1)))
    //.range([0, width]);

    const labels = data.map(({ YearName }) => YearName);

    // Update xScale domain to include the last label

    const xScale = d3
      .scaleLinear()
      .domain([labels[0], labels[labels.length - 1]])
      .range([0, width]);

    var maxYscale = 0;
    data.map((d) => {
      var localMax = 0;

      Object.values(d).map((d, index, key) => {
        if (index != 0) localMax += d;
      });

      if (localMax > maxYscale) maxYscale = localMax;
    });
    maxYscale = maxYscale + 50;

    const yScale = d3.scaleLinear().domain([0, maxYscale]).range([height, 0]);

    // Define stack
    const stack = d3
      .stack()
      .keys(Object.keys(data[0]).filter((key) => key !== "YearName"))
      .order(d3.stackOrderNone)
      .offset(d3.stackOffsetNone);

    const stackedData = stack(data);

    const area = d3
      .area()
      .x((d, i) => {
        return xScale(d.data.YearName);
      })
      .y0((d) => yScale(d[0]))
      .y1((d) => yScale(d[1]));

    // Add the stacked areas
    svg
      .selectAll("path")
      .data(stackedData)
      .enter()
      .append("path")
      .attr("class", (d, i) => `area${i + 1}`)
      .attr("d", (d, i) => {
        return area(d);
      })
      .attr("fill", (d, i) => colorsForBars[i])
      .on("mouseover", handleMouseOver)
      .on("mouseout", handleMouseOut);

    // Add x-axis

    // Add x-axis
    svg
      .append("g")
      .attr("transform", `translate(0,${height})`)
      .call(
        d3
          .axisBottom(xScale)
          .tickValues(data.map((d) => d.YearName))
          .tickFormat((d) => {
            return getAcademicYear(d);
          }) // Set tick values to the year names
      );

    // Add y-axis
    svg.append("g").call(
      d3
        .axisLeft(yScale)
        .tickValues(
          d3.range(0, maxYscale + 10, Math.round(maxYscale / 10) * 10)
        )
        .tickFormat(function (d, i) {
          return d?.toLocaleString();
        })
    );

    // Add legend items
    // const legendItems = legendSvg
    //   .selectAll(".legend-item")
    //   .data(Object.keys(data[0]).filter((key) => key !== "YearName"))
    //   .enter()
    //   .append("g")
    //   .attr("class", "legend-item")
    //   .attr("transform", (d, i) => `translate(0,${i * 20})`);

    // legendItems
    //   .append("rect")
    //   .attr("width", 18)
    //   .attr("height", 18)
    //   .attr("fill", (d, i) => colorsForBars[i]);

    // legendItems
    //   .append("text")
    //   .attr("x", 24)
    //   .attr("y", 9)
    //   .attr("dy", ".35em")
    //   .text((d) => d);

    // Tooltip
    const tooltip = d3
      .select("#stacked-area-graph-container")
      .append("div")
      .attr("class", "tooltip area-tip")
      .style("opacity", 0);
    function handleMouseOver(event, d) {
      const xPos = event.pageX;
      const range = xScale.range();

      const stepSize = (range[1] - range[0]) / (labels.length - 1);

      const firstaxis = svg.node() || null;
      if (firstaxis != null) {
        const anyother = firstaxis.getBoundingClientRect();
        const offsetX = xPos - anyother.left - margin.left + 35;
        const container = document.getElementById("stacked-area-graph-container");
        const containerRect = container.getBoundingClientRect();
        const tooltipTop = event.pageY - containerRect.top;
        let y = event.clientY;
        const xAxisDataIndex = Math.floor(offsetX / stepSize); // Using Math.floor to get the index
        if (xAxisDataIndex > -1 && xAxisDataIndex < labels.length) {
          const year = labels[xAxisDataIndex];
          const values = Object.entries(d[xAxisDataIndex].data)
            .filter(([key, value]) => key !== "YearName")
            .map(([key, value]) => `<td>${key}</td> <td>${value.toLocaleString()}</td>`)
            .join("</tr><tr>");
          tooltip.attr("className", "");
          tooltip.style("opacity", 0.9);
          tooltip.style("display", "");
          const maxTop = window.innerHeight - (values.length*1)+700; // Adjust as needed
        let top =  y > maxTop ? maxTop : y;
      
        tooltip.style("top", `${top}px`);
          tooltip
          .html('')
          .html(`<div><table><tr><td>Year</td><td> ${year}</td></tr><tr>${values}</tr></table></div>`)
            .style("left", `${event.pageX}px`)
            
        }
      }
    }

    function handleMouseOut() {
      tooltip.attr("className", "no-display");
      tooltip.style("opacity", 0);
      tooltip.style("display", "none");
    }

    // Cleanup on unmount
    return () => {
      d3.select("#stacked-area-graph-container").selectAll("*").remove();
      d3.select("#stacked-area-legend-container").selectAll("*").remove();
    };
  }, [props.data]);

  return (
    <div>
      <div id="stacked-area-graph-container" />
      {/* <div id="stacked-area-legend-container" /> */}
      <div className="Legend-main3">
        
      {Arealegends &&
            Arealegends.length > 0 &&
            Arealegends.map((Item, index) => (
              Item!="YearName" &&
              <div className="leg-item">
                <span className={"clegend-" + (index-1)}></span>
                <p>{Item}</p>
              </div>
            ))}
      </div>
    </div>
  );
};

export default AreaGraphND1;
